import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/** Notifies the config categories section that a category's types changed (editor save). */
@Injectable()
export class PermitConfigRefreshService {
    readonly categoryChanged$ = new Subject<string>();

    notifyCategoryChanged(categoryId: string): void {
        this.categoryChanged$.next(categoryId);
    }
}
